import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "ProjectType/";

const getProjectTypeById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProjectTypeById?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getProjectTypes = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetProjectTypes', constants.REQUIRE_INTERCEPTORS);

const getProjectTypesWithSubTypes = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetProjectTypesWithSubTypes', constants.REQUIRE_INTERCEPTORS);

const saveProjectType = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveProjectType', model, constants.REQUIRE_INTERCEPTORS);

const deleteProjectType = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteProjectType?id=' + id, constants.REQUIRE_INTERCEPTORS);

export {
    getProjectTypeById,
    getProjectTypesWithSubTypes,
    getProjectTypes,
    saveProjectType,
    deleteProjectType
}